import type { Feature, AboutStats } from '../types/about.types';

export const APP_VERSION = '1.0.0';
export const COMPANY_NAME = 'Сканта';
export const COPYRIGHT_YEAR = 2026;

export const HERO_CONTENT = {
    logo: 'S',
    title: COMPANY_NAME,
    subtitle: 'Система слежения за состоянием ваших сайтов и финансов',
    description: 'Мы следим круглосуточно, чтобы вы могли быть уверены — всё работает. Мгновенные уведомления о сбоях, детальная аналитика и удобный доступ к финансовым данным в одном месте.',
};

export const FEATURES: Feature[] = [
    {
        id: 'monitoring',
        icon: 'Shield',
        title: 'Круглосуточно',
        description: 'Ваши сайты проверяются каждые 60 секунд, 24 часа в сутки. Ни один сбой не останется незамеченным.',
        color: 'emerald',
    },
    {
        id: 'instant',
        icon: 'Zap',
        title: 'Мгновенно',
        description: 'Узнаёте о сбое раньше, чем его заметят ваши клиенты. Push-уведомления прямо на телефон.',
        color: 'amber',
    },
    {
        id: 'simple',
        icon: 'Smile',
        title: 'Понятно',
        description: 'Никаких технических терминов — только чёткий статус. Интуитивный интерфейс без обучения.',
        color: 'blue',
    },
    {
        id: 'mobile',
        icon: 'Smartphone',
        title: 'Всегда рядом',
        description: 'Работает как приложение на телефоне и планшете. PWA-технологии для максимального удобства.',
        color: 'purple',
    },
    {
        id: 'finance',
        icon: 'Wallet',
        title: 'Финансы',
        description: 'Интеграция с 1С для отслеживания остатков денежных средств в реальном времени.',
        color: 'cyan',
    },
    {
        id: 'secure',
        icon: 'Lock',
        title: 'Безопасно',
        description: 'Шифрование данных, безопасная аутентификация и соответствие стандартам защиты информации.',
        color: 'rose',
    },
];

export const STATS: AboutStats[] = [
    { label: 'Время работы', value: '99.5', suffix: '%' },
    { label: 'Сайтов на мониторинге', value: '100', suffix: '+' },
    { label: 'Уведомлений в день', value: '20', suffix: 'K' },
    { label: 'Довольных клиентов', value: '2', suffix: '+' },
];